export const iconFontAwesomeDisasterCrisisRadiation = (
	<i className="fa-solid fa-radiation"></i>
);
